export enum JobStatus {
  SUBMITTED = "SUBMITTED",
  PROGRESSING = "PROGRESSING",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
  BLOCKED = "BLOCKED",
  REGISTERED = "REGISTERED",
  FAILED = "FAILED",
  UNSUCCESSFUL = "UNSUCCESSFUL",
  SUCCESS = "SUCCESS",
  INACTIVE = "INACTIVE",
}
export enum BackfillStatus {
  SUBMITTED = "SUBMITTED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  FAILED = "FAILED",
  UNSUCCESSFUL = "UNSUCCESSFUL",
}

export enum TaskStatus {
  SUBMITTED = "SUBMITTED",
  PROGRESSING = "PROGRESSING",
  COMPLETE = "COMPLETE",
  REGISTERED = "REGISTERED",
  DEPRECATED = "DEPRECATED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  ERROR = "ERROR",
  INACTIVE = "INACTIVE",
}

export function parseJobStatus(value: string): JobStatus {
  const status = JobStatus[value.toUpperCase() as keyof typeof JobStatus];
  if (status === undefined) {
    throw new Error(`Invalid job status string: ${value}`);
  }
  return status;
}

export function parseTaskStatus(value: string): TaskStatus {
  const status = TaskStatus[value.toUpperCase() as keyof typeof TaskStatus];
  if (status === undefined) {
    throw new Error(`Invalid task status string: ${value}`);
  }
  return status;
}
